import $ from '/js/header/jquery.js';
import { ListViewHelper } from "/js/tools/common-board/ListViewHelper";
const listViewHelper = new ListViewHelper();

$(() => {
    (function (window) {
        if (!window.history.enabled) {
            return false;
        }
        window.history.pushState({section: 1, page_index: 1}, "탱크옥션", "?page=1");
        window.history.Adapter.bind(window, 'statechange', function () {
            //페이지 선택시 실행
            var State = window.history.getState();
            if (listViewHelper.manualChange) return false;
            loadPage(State.data['page_index']);
        });
    })(window);
    $(".tab_menu ul .tab_9:first").addClass("on");
    $(".tab_menu ul .tab_9").click(function () {
        $("#id_code").val($(this).data('code'));
        $("#txtSrch").val("");
        $("#pageNo").val(1);
        $("#srch_type option:eq(0)").prop("selected", true);
        $(".tab_menu ul .tab_9").removeClass("on");
        $(this).addClass("on");
        list();
    });
    $("#btnSrch").click(function () {
        $("#pageNo").val(1);
        list();
    });
    loadPage($("#pageNo").val());
});

function list() {
    let html = "";
    $.ajax(
        {
            type: "POST",
            url: "/study/res/Study.php",
            data: $("#fmSrch").serialize(),
            dataType: "JSON",
            success: function (data) {
                if (data.totCnt > 0) {
                    $.each(data.items, function () {
                        var txtSrch = this.txtSrch;
                        html += `
                            <tr height='40' class='list' data-id=${this.id_num} data-txt='${txtSrch}'">
                                <td class='center'>${this.No}</td>
                                <td class='center'>${this.dv}</td>
                                <td>${this.title}</td>
                            </tr>
                        `;
                    });
                    $("#paging").show();
                    $("#paging").html(listViewHelper.paging(data.totCnt, $("#pageNo").val(), loadPage, $("#dataSize").val(), $("#pageSize").val()));
                    window.history.pushState({
                        section: 1,
                        page_index: $("#pageNo").val()
                    }, "두인옥션", `?page=${$("#pageNo").val()}`);

                    listViewHelper.manualChange = false;
                    setTimeout(function () {
                        listMouseOver($(".list"));
                    }, 80);
                } else {
                    $("#paging").hide();
                    $("#ltTbody").html("");
                    html = `
                        <tr style='line-height:200px'>
                            <td colspan='15' style='text-align:center;font-size:14px;color:#555'>검색 결과가 없습니다.</td>
                        </tr>`;
                }
                $("#ltTbody").html(html);
                listViewHelper.formSrchStyle(fmSrch);

                // 리스트 클릭 이벤트
                $(".list").on("click", (e) => {
                    const id_num = $(e.currentTarget).data("id");
                    const txtSrch = $(e.currentTarget).data("txt");
                    read(id_num, txtSrch);
                });
            }
        });
}

function loadPage(v) {
    $("#pageNo").val(v);
    list();
}

function read(id_num, txtSrch) {
    location.href = `/study/auct_faq_view.php?id_num=${id_num}&txtSrch=${txtSrch}&pageNo=${$("#pageNo").val()}`;
}

//list mouseover
function listMouseOver(row) {
    row.mouseover(function () {
        $(this).css({"background": "#F1F7FC", "cursor": "pointer"});
    }).mouseout(function () {
        $(this).css({"background": "#fff"});
    });
}